module.exports = __webpack_public_path__ + "static/media/header-11.f1671e69.png";